import React, { useContext } from "react";
import style from "./ProcesElement.module.css";
import iconX from "assets/xDark.svg";
import iconTrash from "assets/trash2.svg";
import { AppContext } from "context/AppContext";
import { ModalInsertContext } from "context/ModalInsertContext";
import { addNewProcess } from "actions/addProcess";
import { _typ_elementu, reg_int, reg_txt } from "utils/initialvalue";
import { useHistoria } from "hooks/useHistoria";
import { getNameOfElement } from "actions/getNameOfElement";
import { useStatus } from "hooks/useStatus";

export default function ProcesElement({ showElementyProcesyInsert }) {
  if (!showElementyProcesyInsert) return null;

  return (
    <Window>
      <Header />
      <Table />
      <Footer />
    </Window>
  );
}

function Window({ children }) {
  return (
    <div className={style.blurContainer}>
      <div className={style.window}>{children}</div>
    </div>
  );
}

function Header() {
  const modalContext = useContext(ModalInsertContext);
  const appContext = useContext(AppContext);
  const rowElement = modalContext.selectedElementROW;
  const listaPapierowWyszukiwarka = appContext.listaPapierowWyszukiwarka;

  const papier = (papier_id) => {


let nazwa = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.nazwa || ' '
let gramatura = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.gramatura || ' '
let wykonczenie = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.wykonczenie || ' '

    return `${nazwa} ${gramatura} ${wykonczenie}  `
  }

  const typNazwa = appContext.typ_elementu?.find((x) => x?.id === rowElement?.typ)?.nazwa;

  return (
    <div className={style.header}>
      <div className={style.titleWrapper}>
        <h2 className={style.title}>Procesy</h2>
      {/* <p className={style.title}>  <p className={style.title2}>{appContext.typ_elementu?.filter(x => x.id == rowElement?.typ)[0]?.nazwa} {rowElement?.naklad} szt. {rowElement?.nazwa} - {papier(rowElement?.papier_id)}</p> </p>  */}

        <span className={style.subtitle}>
          {appContext.typ_elementu?.filter(x => x.id == rowElement?.typ)[0]?.nazwa} &bull; {rowElement?.naklad} szt. &bull;  {papier(rowElement?.papier_id)}

        </span>
      </div>
      <Zamknij />
    </div>
  );
}

function Zamknij() {
  const modalContext = useContext(ModalInsertContext);

  return (
    <button
      className={style.btnClose}
      onClick={() => modalContext.setShowElementyProcesyInsert(false)}
      title="Zamknij"
    >
      <img src={iconX} alt="Zamknij" />
    </button>
  );
}

function Footer() {
  const modalContext = useContext(ModalInsertContext);
  const setProcesyElementow = modalContext.setProcesyElementow;
  const procesyElementowTemporary = modalContext.procesyElementowTemporary;
  const elementy = modalContext.elementy;
  const daneZamowienia = modalContext.daneZamowienia;
  const [add] = useHistoria();
  const [setStatus] = useStatus();

  const handleSave = () => {
    modalContext.setShowElementyProcesyInsert(false);
    setProcesyElementow(
      procesyElementowTemporary.map((row) => {
        if (row.delete === true && row.historia !== true) {
          add({
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id, elementy, _typ_elementu) + " - kasowanie procesu",
            zamowienie_id: daneZamowienia.id,
          });
          setStatus(3);
          return { ...row, historia: true };
        }

        if (row.insert === true && row.historia !== true && row.update !== true) {
          add({
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id, elementy, _typ_elementu) + " - dodanie procesu",
            zamowienie_id: daneZamowienia.id,
          });
          setStatus(3);
          return { ...row, historia: true };
        }

        if (row.update === true && row.historia === false) {
          add({
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id, elementy, _typ_elementu) + " - zmiana procesu",
            zamowienie_id: daneZamowienia.id,
          });
          setStatus(3);
          return { ...row, historia: true };
        }

        return row;
      })
    );
  };

  return (
    <div className={style.footer}>
      <button className={style.btnSecondary} onClick={() => modalContext.setShowElementyProcesyInsert(false)}>
        Anuluj
      </button>
      <button className={style.btnPrimary} onClick={handleSave}>
        Zapisz zmiany
      </button>
    </div>
  );
}

function Table() {
  const contexApp = useContext(AppContext);
  const contexModal = useContext(ModalInsertContext);
  const procesyElementowTemporary = contexModal.procesyElementowTemporary;
  const setProcesyElementowTemporary = contexModal.setProcesyElementowTemporary;
  const procesList = contexApp.procesList;
  const selectedElementROW = contexModal.selectedElementROW;

  const visibleRows = procesyElementowTemporary
    .filter((x) => x.element_id === selectedElementROW.id)
    .filter((x) => x.delete !== true)
    .sort((a, b) => (Number(a.indeks) || 0) - (Number(b.indeks) || 0));

  const handleDragStart = (e, id) => {
    e.dataTransfer.setData("text/plain", id);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, targetRow) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("text/plain");

    if (draggedId === String(targetRow.id)) return;

    const draggedIndex = visibleRows.findIndex((r) => String(r.id) === draggedId);
    const targetIndex = visibleRows.findIndex((r) => r.id === targetRow.id);

    if (draggedIndex === -1 || targetIndex === -1) return;

    const reorderedList = [...visibleRows];
    const [draggedItem] = reorderedList.splice(draggedIndex, 1);
    reorderedList.splice(targetIndex, 0, draggedItem);

    const updatedVisibleRowsMap = new Map(
      reorderedList.map((item, index) => [
        item.id,
        { ...item, indeks: index + 1, update: true },
      ])
    );

    setProcesyElementowTemporary((prev) =>
      prev.map((item) => updatedVisibleRowsMap.get(item.id) || item)
    );
  };

  return (
    <div className={style.main}>
      <div className={style.tableWrapper}>
        <table className={style.table}>
          <thead>
            <tr>
              <th className={style.colDrag}></th>
              <th className={style.colIndeks}>#</th>
              <th className={style.colProces}>Proces</th>
              <th className={style.colTyp}>Typ</th>
              <th className={style.colUzytki}>Ilość użytków</th>
              <th className={style.colIlosc}>Front</th>
              <th className={style.colIlosc}>Back</th>
              <th className={style.colKolor}>Kolory front</th>
              <th className={style.colKolor}>Kolory back</th>
              <th className={style.colOpis}>Opis</th>
              <th className={style.colAkcje}></th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr
                key={row.id}
                draggable
                onDragStart={(e) => handleDragStart(e, row.id)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, row)}
                className={style.draggableRow}
              >
                <td className={style.dragHandle} title="Przeciągnij, aby zmienić kolejność">
                  ⠿
                </td>
                <INDEKS row={row} />
                <ProcesName row={row} />
                <ProcessTyp row={row} />
                <IloscUzytkow row={row} />
                <FrontIlosc row={row} />
                <BackIlosc row={row} />
                <FrontKolor row={row} />
                <BackKolor row={row} />
                <Info row={row} />
                <Usun row={row} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={style.dodajProcesRow}>
        <button
          className={style.btnOutline}
          onClick={() =>
            addNewProcess(
              selectedElementROW,
              procesyElementowTemporary,
              setProcesyElementowTemporary,
              procesList
            )
          }
        >
          + Dodaj nowy proces
        </button>
      </div>
    </div>
  );
}

const ProcesName = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const contexApp = useContext(AppContext);
  const procesListEdit = JSON.parse(JSON.stringify(contexApp.procesList));
  const procesList = contexApp.procesList;

  return (
    <td>
      <select
        className={style.inputControl}
        value={row.nazwa_id}
        onChange={(e) => {
          let proc = procesList.filter((x) => x.nazwa_id === e.target.value);
          contexModal.handleUpdateRowProcesyElementow({
            ...row,
            ...proc[0],
            nazwa_id: e.target.value,
            proces_id: procesListEdit.find((proces) => proces.nazwa_id === e.target.value)?.id,
            update: true,
            historia: false,
            id: row.id,
          });
        }}
      >
        {Array.from(new Set(contexApp.procesList.filter((x) => x.produkt !== 1).map((option) => option.nazwa))).map((unikalnaNazwa) => {
          const opcja = contexApp.procesList.find((opt) => opt.nazwa === unikalnaNazwa);
          return (
            <option key={opcja.nazwa_id} value={opcja.nazwa_id}>
              {opcja.nazwa}
            </option>
          );
        })}
      </select>
    </td>
  );
};

const ProcessTyp2= ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const contexApp = useContext(AppContext);
  const selectedElementROW = contexModal.selectedElementROW;
  const procesList = contexApp.procesList;

  return (
    <td>
      <select
        className={style.inputControl}
        value={row.proces_id}
        onChange={(e) => {
          let proc = procesList.filter((x) => x.id === e.target.value);
          contexModal.handleUpdateRowProcesyElementow({
            ...row,
            ...proc[0],
            proces_id: e.target.value,
            update: true,
            historia: false,
            id: row.id,
          });
        }}
      >
        {contexApp.procesList
          .filter(
            (p) =>
              p.nazwa_id ===
              contexModal.procesyElementowTemporary.find(
                (x) => x.element_id === selectedElementROW.id && x.indeks === row.indeks
              )?.nazwa_id
          )
          .map((option) => (
            <option key={option.id} value={option.id}>
              {option.typ} {option.rodzaj} {option.wykonczenie} {option.obszar}
            </option>
          ))}
      </select>
    </td>
  );
};


const ProcessTyp = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const contexApp = useContext(AppContext);
  const procesList = contexApp.procesList || [];

  // Filtrujemy listę typów bezpośrednio po nazwa_id z aktualnego wiersza (row)
  const dostepneTypy = procesList.filter((p) => p.nazwa_id == row.nazwa_id);

  return (
    <td>
      <select
        className={style.inputControl}
        value={row.proces_id || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          const proc = procesList.find((x) => x.id == selectedValue);

          contexModal.handleUpdateRowProcesyElementow({
            ...row,
            ...proc,
            proces_id: selectedValue,
            update: true,
            historia: false,
            id: row.id,
          });
        }}
      >
        {dostepneTypy.map((option) => (
          <option key={option.id} value={option.id}>
            {option.typ} {option.rodzaj} {option.wykonczenie} {option.obszar}
          </option>
        ))}
      </select>
    </td>
  );
};










const BackKolor = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={style.inputControl}
        value={row.back_kolor || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              back_kolor: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const FrontKolor = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={style.inputControl}
        value={row.front_kolor || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              front_kolor: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const INDEKS = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        draggable={false}
        onDragStart={(e) => e.stopPropagation()}
        className={`${style.inputControl} ${style.centerText}`}
        value={row.indeks || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              indeks: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const IloscUzytkow = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={`${style.inputControl} ${style.centerText}`}
        value={row.ilosc_uzytkow || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              ilosc_uzytkow: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const FrontIlosc = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={`${style.inputControl} ${style.centerText}`}
        value={row.front_ilosc || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              front_ilosc: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const BackIlosc = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={`${style.inputControl} ${style.centerText}`}
        value={row.back_ilosc || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              back_ilosc: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

const Info = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  return (
    <td>
      <input
        className={style.inputControl}
        value={row.info || ""}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            contexModal.handleUpdateRowProcesyElementow({
              ...row,
              info: e.target.value,
              update: true,
              historia: false,
            });
          }
        }}
      />
    </td>
  );
};

function Usun({ row }) {
  const contexModal = useContext(ModalInsertContext);
  const procesyElementowTemporary = contexModal.procesyElementowTemporary;
  const setProcesyElementowTemporary = contexModal.setProcesyElementowTemporary;

  const handleDelete = () => {
    if (row.zamowienie_id === 1) {
      setProcesyElementowTemporary(procesyElementowTemporary.filter((p) => p.id !== row.id));
    } else {
      setProcesyElementowTemporary((prev) =>
        prev.map((t) => (t.id === row.id ? { ...t, delete: true } : t))
      );
    }
  };

  return (
    <td className={style.colAkcje}>
      <button className={style.btnDelete} onClick={handleDelete} title="Usuń proces">
        <img src={iconTrash} alt="Usuń" />
      </button>
    </td>
  );
}